import { MobileMenu } from './MobileMenu';

export default MobileMenu;
export type { MobileMenuProps } from './types';
